import { render, staticRenderFns } from "./Integer.vue?vue&type=template&id=53ae94d4"
import script from "./Integer.vue?vue&type=script&lang=ts"
export * from "./Integer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports